import { Controller } from "@hotwired/stimulus";

// Live line/grand total calculation for the purchase order line items table.
// Composed alongside the generic `nested-fields` controller on the same element.
//
// Connects to data-controller="purchase-order-items"
export default class extends Controller {
  static targets = ["row", "grandTotal"];

  recalculate(event) {
    const row = event.target.closest(`[data-${this.identifier}-target="row"]`);
    if (!row) return;

    const lineTotalTarget = row.querySelector(`[data-${this.identifier}-target="lineTotal"]`);
    if (lineTotalTarget) lineTotalTarget.textContent = this.formatCurrency(this.lineTotalFor(row));

    this.updateGrandTotal();
  }

  updateGrandTotal() {
    const total = this.rowTargets
      .filter((row) => !row.hidden)
      .reduce((sum, row) => sum + this.lineTotalFor(row), 0);

    if (this.hasGrandTotalTarget) this.grandTotalTarget.textContent = this.formatCurrency(total);
  }

  lineTotalFor(row) {
    const quantity = parseFloat(row.querySelector(`[data-${this.identifier}-target="quantity"]`)?.value) || 0;
    const unitPrice = parseFloat(row.querySelector(`[data-${this.identifier}-target="unitPrice"]`)?.value) || 0;

    return quantity * unitPrice;
  }

  formatCurrency(amount) {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(amount);
  }
}
